/* eslint-disable no-param-reassign */

function isEmpty(value) {
  return value === null || value === '' || typeof value === 'undefined';
}

export default function (sortOrder) {
  return (value, nextValue) => {
    if (typeof value === 'string') value = value.toLowerCase();

    if (typeof nextValue === 'string') nextValue = nextValue.toLowerCase();

    if (value === nextValue) return 0;

    if (isEmpty(value)) {
      if (isEmpty(nextValue)) return 0;

      return 1;
    }

    if (isEmpty(nextValue)) return -1;

    if (Number.isNaN(value) && !Number.isNaN(nextValue)) {
      return sortOrder === 'asc' ? 1 : -1;
    }

    if (!Number.isNaN(value) && Number.isNaN(nextValue)) {
      return sortOrder === 'asc' ? -1 : 1;
    }

    if (!(Number.isNaN(value) || Number.isNaN(nextValue))) {
      const matchedValue = value.match(/\d+/);
      const matchedNextValue = nextValue.match(/\d+/);
      value = matchedValue ? matchedValue[0] : value;
      nextValue = matchedNextValue ? matchedNextValue[0] : nextValue;
    }

    if (value < nextValue) return sortOrder === 'asc' ? -1 : 1;

    if (value > nextValue) return sortOrder === 'asc' ? 1 : -1;

    return 0;
  };
}
